import {DATATABLE_CLEAR_SEARCH} from '~/frontend/src/constants';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import unsetParamOrig, {UnsetParamAction} from '~/frontend/src/actions/panel/common/unsetParam';
import {
    clearElusiveData,
    setElusiveData as setElusiveDataOrig,
    SetElusiveDataAction
} from '~/frontend/src/actions/elusiveData';
import {
    AllProps,
    PanelElusiveData
} from '~/frontend/src/components/base/DataTable';


type UnsetParam = ( panelKey : string, paramKey : keyof AllProps ) => UnsetParamAction;
type SetElusiveData = ( panelKey : string, data : PanelElusiveData ) => SetElusiveDataAction;


const unsetParam     = unsetParamOrig as UnsetParam,
      setElusiveData = setElusiveDataOrig as SetElusiveData;


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {Function}
 */
const clearSearch = ( panelKey : string ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) : void => {
    const elusiveData       = getState().elusiveData?.[ panelKey ],
          columnsCache      = elusiveData?.columnsCache,
          forceFilterToggle = elusiveData?.forceFilterToggle ?? 0;

    dispatch( {
        type: DATATABLE_CLEAR_SEARCH,
        panelKey
    } );

    dispatch( unsetParam( panelKey, 'searchString' ) );
    dispatch( unsetParam( panelKey, 'filters' ) );
    //dispatch( unsetParam( panelKey, 'sorters' ) );
    dispatch( unsetParam( panelKey, 'search' ) );
    dispatch( unsetParam( panelKey, 'doSearch' ) );
    dispatch( unsetParam( panelKey, 'page' ) );

    dispatch( clearElusiveData( panelKey ) );

    if ( columnsCache ) {
        for ( const field of Object.keys( columnsCache ) ) {
            columnsCache[ field ].cellCache = {};
        }

        dispatch( setElusiveData( panelKey, { columnsCache } ) );
    }

    dispatch( setElusiveData( panelKey, { forceFilterToggle: forceFilterToggle + 1 } ) );
}
export type ClearSearch = typeof clearSearch;

export default clearSearch;
